import React from "react";
import { Link } from "react-router-dom";
import { MetaLabel, CornerTick } from "../brand/Brand";

/* Reusable end-of-page call to action. Dropped on content pages that would
 * otherwise dead-end (blog, legal) so the site always closes on an invitation
 * to act. Home / Work / Case Study keep their own bespoke closers. */
const tile = {
  color: "var(--fw-cream)",
  textDecoration: "none",
  display: "block",
  padding: "20px 24px",
  background: "var(--fw-ink)",
  fontFamily: "var(--fw-mono)",
  fontSize: 15,
  letterSpacing: 0.5,
  transition: "opacity 0.15s",
};

const tileLabel = {
  fontSize: 10,
  opacity: 0.6,
  letterSpacing: "1.4px",
  textTransform: "uppercase",
  marginBottom: 6,
};

const CTABanner = ({
  eyebrow = "Let's talk / Currently booking",
  heading = (
    <>
      Got a thing
      <br />
      to build?
    </>
  ),
}) => (
  <section
    style={{
      padding: "120px 40px",
      background: "var(--fw-red)",
      color: "var(--fw-cream)",
    }}
  >
    <div style={{ maxWidth: 1440, margin: "0 auto", position: "relative" }}>
      <CornerTick pos="tl" color="var(--fw-cream)" />
      <CornerTick pos="tr" color="var(--fw-cream)" />
      <CornerTick pos="bl" color="var(--fw-cream)" />
      <CornerTick pos="br" color="var(--fw-cream)" />
      <div style={{ padding: "32px 16px" }}>
        <div
          className="cta-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "2fr 1fr",
            gap: 80,
            alignItems: "flex-end",
          }}
        >
          <div>
            <MetaLabel color="rgba(243,239,232,0.75)">{eyebrow}</MetaLabel>
            <div
              style={{
                fontSize: "clamp(56px, 8vw, 128px)",
                lineHeight: 0.9,
                letterSpacing: -5,
                fontWeight: 800,
                marginTop: 24,
              }}
            >
              {heading}
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <Link
              to="/start"
              style={tile}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.85")}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
            >
              <div style={tileLabel}>Start a project · 2-min brief</div>
              Begin intake →
            </Link>
            <a
              href="mailto:jm@bboycreative.com"
              style={tile}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.85")}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
            >
              <div style={tileLabel}>Email</div>
              jm@bboycreative.com
            </a>
          </div>
        </div>
      </div>
    </div>

    <style>{`
      @media (max-width: 768px) {
        .cta-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
      }
    `}</style>
  </section>
);

export default CTABanner;
